import { render, staticRenderFns } from "./FileViewer.vue?vue&type=template&id=a72cd7be&scoped=true&"
import script from "./FileViewer.vue?vue&type=script&lang=js&"
export * from "./FileViewer.vue?vue&type=script&lang=js&"
import style0 from "./FileViewer.vue?vue&type=style&index=0&id=a72cd7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72cd7be",
  null
  
)

export default component.exports